import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import unsplash from "../api/unsplash";
import { DataGrid, GridToolbar, itIT ,GridValueGetterParams } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import {Add,HealthAndSafety,WarningOutlined} from '@mui/icons-material';
import {IconButton,Button,Dialog,DialogTitle,DialogContent,Grid,TextField,FormControl,InputLabel,Select,MenuItem,Popover,DialogActions,Box,Typography,Step,StepLabel,Stepper,CircularProgress} from '@mui/material';
import '../style/style.css';
import moment from "moment";
import momentTimezone from "moment-timezone";
import "moment/locale/it";
import { DateTimePicker ,LocalizationProvider} from "@mui/lab";
import DateAdapter from '@mui/lab/AdapterMoment';
import {HourglassBottom,Error,CheckCircle} from '@mui/icons-material';
import GlobalSnackbar from "./Snackbar";

const Lavoratori = (props) =>{
const [skip,setSkip] = useState(false);
const [lavoratori,setLavoratori] = useState();
const [lavoratoriSelezionati,setLavoratoriSelezionati] = useState([]);
const [medici,setMedici] = useState();
const [esiti,setEsiti] =useState();
const [tipologiaVisita,setTipologiaVisita] =useState();
const [anchorEl, setAnchorEl] = useState(null);
const navigate = useNavigate();

const columns = [
  { field: 'StatoVisita', headerName: '*',width: 20, 
renderCell: (params) =>//mi aiuta a mettere il valore

(
<div>

  {
  params.row.StatoVisita ==="OK"?<CheckCircle sx={{color:"green"}}/>:<Error sx={{color:params.row.StatoVisita==="InScadenza"?"orange":params.row.StatoVisita==="Parziale"?"blue":"red"}}/>
}


</div>


)  
},
{ field: 'Visita', headerName: '*',width: 10, 
renderCell: (params) =>//mi aiuta a mettere il valore

(
<div>

  {
  
/*1*/ params.row.DataUltimaVisita< moment(new Date()).format("YYYY-MM-DD") && params.row.DataUltimaVisita !== null && params.row.Esito<=1  ?<HourglassBottom sx={{color:"red"}}/>:(  
/*2*/ params.row.DataUltimaVisita === null?"":(
/*3*/  params.row.Esito > 1?<HourglassBottom sx={{color:"green"}}/>:<HourglassBottom sx={{color:"blue"}}/>))
}


</div>


)  
},

  { field: 'Cognome', headerName: 'Cognome', width: 200 },
  { field: 'Nome', headerName: 'Nome', width: 200 },
  { field: 'Descrizione', headerName: 'Mansione', width: 300 },
  { field: 'SedeDesc', headerName: 'Sede', width: 300 },
  { field: 'SedeBlocco', headerName: 'Blocco', width: 300 },
  { field: 'ID', headerName: 'Azioni', hide: false, width :"130",
  renderCell: (params) => ( //mi aiuta a mettere il valore
  <IconButton aria-label="edit" onClick={() => {navigate("/dettaglioLavoratore", {state: {lavoratore: params.row}})}}>
  <EditIcon 
  style={{height:"2rem",width:"2rem",color:"#2264ae"}}
 
    />
</IconButton>

  )



}
];


useEffect( async () => {

  
       /* let responseAziendali =  await unsplash
          .get('lavoratori',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          },params:{id:props.idAzienda}}
           );
     
        setLavoratori(responseAziendali.data.data);
*/        let lav = await props.Lavoratori;
          console.log(lav);
          setLavoratori(lav.data.data); //è una promise
  
        let responseMedici =  await unsplash
        .get('medici',{ headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        },params:{id:props.idAzienda}}
         );
         setMedici(responseMedici.data.data);

         let responseEsiti =  await unsplash
         .get('esiti',{ headers: {
           'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
         }}
          );
          setEsiti(responseEsiti.data.data);

          let responseTipologiaVisita =  await unsplash
          .get('tipologiaVisita',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          }}
           );
           setTipologiaVisita(responseTipologiaVisita.data.data);



},[]);


const massiveVisit = (e) => {
if (lavoratoriSelezionati.length>0){
setSkip(false);
document.getElementById("myDialog").click();
}else{ //se vuoto mostro l'alert
  setAnchorEl(e.currentTarget);
}

}
const handleCloseEl = () => {
  setAnchorEl(null);
};


    return <div>


 {
lavoratori === undefined?
<CircularProgress  color="primary"/>:
<>
<MyDialog lavoratori={lavoratoriSelezionati} medici={medici} esiti={esiti} tipologiaVisita={tipologiaVisita} cliente={props.idAzienda}/> {/* passo le righe selezionate*/}
<IconButton aria-label="edit">
    <Add 
    style={{height:"2rem",width:"2rem",color:"#2264ae"}}
      />
  </IconButton>

  <IconButton aria-label="edit" onClick={massiveVisit} >
    <HealthAndSafety 
    style={{height:"2rem",width:"2rem",color:"red"}}
      />
  </IconButton>
  <Popover
        id={Boolean(anchorEl)?'simple-popover' : undefined}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      ><div style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    }}>
        <WarningOutlined sx={{marginLeft:"10px",color:"orange"}} />
        <Typography sx={{ p: 2 }}>Selezionare almeno un lavoratore!</Typography>
    </div>  
        
      </Popover>


<div style={{ height: 600, width: '100%' }}>
<DataGrid
    components={{ Toolbar: GridToolbar }}
      localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
      rows={lavoratori}
      getRowId={lavoratori => lavoratori.ID}
      columns={columns}
    onSelectionModelChange={(ids) => {
      const selectedIDs = new Set(ids);
      const selectedRowData = lavoratori.filter((row) =>
        selectedIDs.has(row.ID),
      );
      setLavoratoriSelezionati(selectedRowData)
    }}
      checkboxSelection
    />
    

    </div>
    </>
/*lavoratori?.map(lavoratore =>
  
  
  
  <p>{lavoratore.Nome} {lavoratore.Cognome} </p>)*/


 }
 
    </div>

}

export default Lavoratori

const MyDialog = (props) => {
const [medicoSel,setMedicoSel] = useState("");
const [esitoSel,setEsitoSel] = useState("");
const [tipologiaSel,setTipologiaSel] = useState("");
const [dataSel,setDataSel] = useState(new Date());
const [open, setOpen] = useState(false);
const [activeStep, setActiveStep] = useState(0);
const [skipped, setSkipped] = useState(new Set());
const [accertamenti,setAccertamenti] = useState([]);
const [selectionModel, setSelectionModel] = useState([]);
const [required,setRequired] = useState({medico:false,data:false,tipo:false})
const [openSnack, setOpenSnack] = useState(false);
const [snack,setSnack] = useState({severity:"success",messaggio:"Salvataggio Effettuato correttamente",open:false});

const handleCloseSnack = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }
  setOpenSnack(false);
}

const columns = [
    { field: 'Descrizione', headerName: 'Accertamento', width: 300 },
    { field: 'Scadenza', headerName: 'Scadenza', type:"date",width: 150,
    editable: true, 
      renderCell: (params) => ( 
params.row.Scadenza?moment(params.row.Scadenza).format("DD/MM/YYYY"):""
  
    )  },
    { field: 'Importo', headerName: 'Importo €', type:"number", width: 120 ,editable: true,
    renderCell: (params) => ( 
      params.row.Importo?params.row.Importo:0
          ) 
  
  },
    { field: 'ImportoPassivo', headerName: 'ImportoPassivo €',type:"number", width: 150,editable: true,
    renderCell: (params) => ( 
      params.row.ImportoPassivo?params.row.ImportoPassivo:0
        
          )   }
  ];



const loadVisitaLavoratore = async(val) => {

  let responseAccertamenti =  await unsplash
        .get('accertamenti',{ headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        },params:{cliente:props.cliente,ultimaVisita:props.lavoratori[val].IDUltimaVisita?props.lavoratori[val].IDUltimaVisita:0}}
         );
         setAccertamenti(responseAccertamenti.data.data);
         console.log(responseAccertamenti.data.data);
         setSelectionModel(() =>
         responseAccertamenti.data.data.filter((a) => a.Presente > 0),)


} 


  const handleClickOpen = async () => {
    await setRequired({medico:false,data:false,tipo:false}); 
    loadVisitaLavoratore(0);
    setActiveStep(0);
    setDataSel(new Date());
    setOpen(true);
    await setMedicoSel("");
    await setEsitoSel("");
    await setTipologiaSel("");
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleNext = async () => { //qua faccio le operazioni ogni volta
    let newSkipped = skipped;

    if(activeStep+1 < props.lavoratori.length){
      loadVisitaLavoratore(activeStep+1)
    }
  await setRequired({medico:false,data:false,tipo:false}); 
  await setDataSel(new Date());
  await setMedicoSel("");
  await setEsitoSel("");
  await setTipologiaSel("");
  setActiveStep((prevActiveStep) => prevActiveStep + 1);
  setSkipped(newSkipped);
    /*if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
   
    */
    //qui devo caricare con la query i dati

  };

  const handleSave = async() => {
    let req ={...required};
    let checkOk=true; //lo uso per controllare che tutto sia ok
    if(medicoSel ==="" || medicoSel ===null){
      req.medico =true;
      checkOk=false;
    }else{req.medico =false}  
    if(tipologiaSel ==="" || tipologiaSel ===null){
      req.tipo =true;
      checkOk=false;
    }else{req.tipo =false} 

    if(dataSel ==="" || dataSel ===null){
      req.data =true;
      checkOk=false;
    }else{req.data =false} 

    setRequired(req)
    if(checkOk){

      try{
      let response = await unsplash.post('visiteMediche',{accertamenti:selectionModel,medico:medicoSel,cliente:props.cliente,mansione:props.lavoratori[activeStep].Mansione,data:dataSel,esito:esitoSel,tipoVisita:tipologiaSel,lavoratore:props.lavoratori[activeStep].ID,vecchiaVisita:props.lavoratori[activeStep].IDUltimaVisita},
      { headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
      }}  ); 
      setSnack({severity:"success",messaggio:"Visita Medica creata con successo"}) ; setOpenSnack(true);
    }catch{
      alert("errore");
    }
    }

  }





  return (
    <div>
      <GlobalSnackbar severity={snack.severity} messaggio={snack.messaggio} openSnack={openSnack} handleCloseSnack={handleCloseSnack}/>
      <Button variant="outlined" sx={{display:"none"}} onClick={handleClickOpen} id="myDialog">
        Open form dialog
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth={true}
      maxWidth="lg"
        >
        <DialogTitle>Visita Massiva</DialogTitle>
        <DialogContent>
        <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} >
        {props.lavoratori.map((lav, index) => {
          const stepProps = {};
          const labelProps = {};
          stepProps.completed = false;
          //if (isStepSkipped(index)) {
           
          //}
          return (
            <Step key={lav.ID} {...stepProps} sx={{display:props.lavoratori[activeStep]?.ID===lav.ID?"Block":"None"}}>
              <StepLabel {...labelProps}>{lav.Cognome +" "+lav.Nome + " - " + lav.Descrizione}  </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === props.lavoratori.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
          Visita Massive completate!
          </Typography>
          {/*<Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleReset}>ESCI</Button>
      </Box> pulsante esci al momento non ci serve*/}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          <Grid container spacing={2}>
  
          <Grid item xs={12}>
          {required.tipo || required.data || required.medico?<p style={{color:"red"}}>controlla i campi obbligatori!</p>:""}
            </Grid>
          <Grid item xs={6}>
       
          <FormControl fullWidth>
  <InputLabel id="demo-simple-select-label">Medico</InputLabel>
  <Select
    error={required.medico}
    helperText={required.medico?"Medico obbligatorio":""}
    labelId="demo-simple-select-label"
    id="demo-simple-select"
    value={medicoSel}
    label="Medico"
    onChange={(e) =>setMedicoSel(e.target.value) }
  >
    {props.medici?.map(medico => <MenuItem key={medico.ID} value={medico.ID}>{medico.Descrizione}</MenuItem>)
    }
  </Select>
</FormControl>
          </Grid>
          <Grid item xs={6}>

          <LocalizationProvider dateAdapter={DateAdapter}>
  <DateTimePicker

  ampmInClock={false}
    renderInput={(props) => <TextField {...props} error={required.data}/>}
    label="Data e ora"
  value={dataSel}
  onChange={(newValue) => {
    setDataSel(newValue);

 }}
  />
</LocalizationProvider>
  </Grid>
  <Grid item xs={12}>
          <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Tipologia Visita</InputLabel>
          <Select
            error={required.tipo}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={tipologiaSel}
            label="Tipologia Visita"
            helperText={required.data?"Tipologia obbligatoria":""}
            onChange={(e) =>setTipologiaSel(e.target.value)}
          >
            {props.tipologiaVisita?.map(tipologia => <MenuItem key={tipologia.ID} value={tipologia.ID}>{tipologia.Descrizione}</MenuItem>)}
          </Select>
          </FormControl>
  </Grid>
  <Grid item xs={12}>
  <div style={{ height: 400, width: '100%' }}>
  <DataGrid
      disableSelectionOnClick
      checkboxSelection 
      disableColumnMenu={true}
      localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
      rows={accertamenti}
      getRowId={accertamenti => accertamenti.ID}
      columns={columns}
      selectionModel={selectionModel?.map(sel => sel.ID)}
      onSelectionModelChange={(ids) => {
        const selectedIDs = new Set(ids);
        const selectedRowData = accertamenti.filter((row) =>
          selectedIDs.has(row.ID),
        );
        console.log(selectedRowData);
        setSelectionModel(selectedRowData)
      }}
      onCellEditCommit={(params, event) => {
        let row = {...params.row};
        row[params.field] = params.value;
     
       let selAcc = [...selectionModel];
        let findIndex = selAcc.findIndex((acc => acc.ID == params.row.ID)); //trovo la posizione
        if(findIndex!==-1){
        selAcc.splice(findIndex,1);
        }
        selAcc.push(row);
        setSelectionModel(selAcc);


      }}
        
    />
      
    

    </div>

  </Grid>  

          <Grid item xs={12}>
          <FormControl fullWidth>
  <InputLabel id="demo-simple-select-label">Esito</InputLabel>
  <Select
    labelId="demo-simple-select-label"
    id="demo-simple-select"
    value={esitoSel}
    label="Esito"
    onChange={(e) =>setEsitoSel(e.target.value) }
    
    //onChange={handleChange}
  >
    {props.esiti?.map(esito => <MenuItem key={esito.ID} value={esito.ID}>{esito.Descrizione}</MenuItem>)
    }
  </Select>
</FormControl>
          </Grid>
          </Grid>
          

          </Box>
        </React.Fragment>
      )}
    </Box>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleNext}>{activeStep === props.lavoratori.length- 1 ? 'Fine' : 'Avanti'}</Button>
          <Button onClick={handleClose} color="error">Esci</Button>
          <Button onClick={handleSave} color="success">Salva</Button>
          
        </DialogActions>
      </Dialog>
    </div>
  );
}



/*
TOGLO GLI ACCERTAMENTI E LI RICREO


*/